import 'jquery-flexdatalist/jquery.flexdatalist'
import 'jquery-flexdatalist/jquery.flexdatalist.css'
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import { getUrlParameter } from '../common/util'

const google = window.google

const $map = document.getElementById('google-map')
const $wrapper = $('.map-wrapper')
const $sidebar = $('.map-sidebar')

const state = {
  map: null,
  locations: [],
  currentLocation: null,
  currentInfoWindow: null,
  mapCenter: null,
  scrollbars: []
}

const fn = {
  init: () => {
    state.locations = window._CampusMap.locations
    state.mapCenter = new google.maps.LatLng(43.034682, -75.008812)

    fn.bindEvents()
    fn.setupMap()

    // Load initial section from url
    const selectedSection = getUrlParameter('section')

    if (selectedSection === 'offices') {
      fn.toggleSidebarSection('#office-locations')
    } else {
      fn.toggleSidebarSection('#campus-locations')
    }
  },

  bindEvents: () => {
    $(window).on('viewinglocation', (e, id) => {
      const location = fn.getLocationById(id)
      state.currentLocation = location

      fn.openInfoWindow(location)
    })

    // Sidebar
    $sidebar.find('.location-header').on('click', function () {
      fn.toggleSidebarSection(`#${$(this).attr('aria-controls')}`)
    })

    $sidebar.find('.location-list').each((_, el) => {
      state.scrollbars.push(new PerfectScrollbar(el, {
        wheelPropagation: true,
        suppressScrollX: true
      }))
    })

    $(window).on('resize', () => {
      state.scrollbars.forEach(sb => sb.update())
    })

    $('.location-list').on('wheel', function (event) {
      const $this = $(this)
      const scrollTop = this.scrollTop
      const scrollHeight = this.scrollHeight
      const height = $this.outerHeight()
      const delta = event.originalEvent.deltaY
      const up = delta < 0

      const prevent = function () {
        event.stopPropagation()
        event.preventDefault()
      }

      if (!up && scrollHeight - height - scrollTop === 0) {
        $this.scrollTop(scrollHeight)
        return prevent()
      } else if (up && scrollTop === 0) {
        $this.scrollTop(0)
        return prevent()
      }
    })

    $('.sidebar-open-button').on('click', fn.showSidebar)
    $('.sidebar-close-button').on('click', fn.hideSidebar)

    $(document).on('mouseenter', '.location-list li button', function () {
      const location = fn.getLocationById($(this).data('id'))

      if (location.marker) {
        location.marker.setAnimation(google.maps.Animation.BOUNCE)
      }
    })
      .on('mouseleave', '.location-list li button', function () {
        const location = fn.getLocationById($(this).data('id'))

        if (location.marker) {
          location.marker.setAnimation(null)
        }
      })
      .on(fn.isMobile() ? 'touchend' : 'click', '.location-list li button', function () {
        const location = fn.getLocationById($(this).data('id'))

        $(window).trigger('viewinglocation', location.id)

        const locationName = location.label.replace(/[^a-zA-Z0-9]+/g, '').replace(/\s+/g, '')

        if (window.dataLayer) {
          window.dataLayer.push({
            'locationName' : locationName,
            'event': 'markerClick'
          })
        }
      })
  },

  setupMap: () => {
    const opts = {
      center: state.mapCenter,
      zoom: 16,
      maxZoom: 20,
      minZoom: 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      scrollwheel: false,
      styles: [
        {
          'featureType': 'administrative',
          'elementType': 'geometry',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'poi',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'transit',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }
      ]
    }

    if (!fn.isMobile()) {
      opts.zoomControl = true

      opts.zoomControlOptions = {
        style: google.maps.ZoomControlStyle.LARGE,
        position: google.maps.ControlPosition.RIGHT_CENTER
      }
    }

    if (window.matchMedia('(max-width: 480px)').matches) {
      opts.zoom = 15
    }

    if (window.matchMedia('(min-width: 1800px)').matches) {
      opts.zoom = 17
    }

    state.map = new google.maps.Map($map, opts)

    google.maps.event.addListenerOnce(state.map, 'tilesloaded', () => {
      fn.setupOverlay()
      fn.placeMarkers()
      fn.setupMapAutocomplete()

      if (window.matchMedia('(min-width: 1024px)').matches) {
        fn.showSidebar()
      }

      // Load selected location from url
      const selectedLocation = getUrlParameter('selected')

      if (selectedLocation) {
        const location = fn.getLocationById(selectedLocation)

        if (location) {
          setTimeout(() => {
            $(window).trigger('viewinglocation', location.id)
          }, 750)
        }
      }
    })
  },

  setupOverlay: () => {
    const bounds = new google.maps.LatLngBounds(
      // Bottom left
      new google.maps.LatLng(43.029386, -75.013932),
      // Top right
      new google.maps.LatLng(43.03794, -75.00202)
    )

    new google.maps.GroundOverlay(window._CampusMap.overlayAssetUrl, bounds, {
      map: state.map
    })
  },


  placeMarkers: () => {
    for (const location of state.locations) {
      fn.setupMarker(location)
      fn.setupInfoWindow(location)
    }
  },

  setupMarker: (location) => {
    const marker = new google.maps.Marker({
      map: state.map,
      title: location.label,
      animation: google.maps.Animation.DROP,
      position: new google.maps.LatLng(location.lat, location.lng),
      panposition: new google.maps.LatLng(location.lat, location.lng),
      icon: location.classname != 'Office' ? window._CampusMap.mapMarkerAssetUrl : window._CampusMap.mapHiddenMarkerAssetUrl
    })

    google.maps.event.addListener(marker, fn.isMobile() ? 'touchend' : 'click', () => {
      if (location.classname != 'Office') {
        $(window).trigger('viewinglocation', location.id)
      }

      const locationName = location.label.replace(/[^a-zA-Z0-9]+/g, '').replace(/\s+/g, '')

      if (window.dataLayer) {
        window.dataLayer.push({
          'locationName': locationName,
          'event': 'markerClick'
        })
      }
    })

    if (!fn.isMobile()) {
      google.maps.event.addListener(marker, 'mouseover', () => {
        marker.setAnimation(google.maps.Animation.BOUNCE)
      })

      google.maps.event.addListener(marker, 'mouseout', () => {
        marker.setAnimation(null)
      })
    }

    location.marker = marker
  },

  setupInfoWindow: (location) => {
    const info = new google.maps.InfoWindow({
      content: location.info
    })

    location.infoWindow = info
  },

  openInfoWindow: (location) => {
    if (!window.matchMedia('(min-width: 1024px)').matches) {
      fn.hideSidebar()
    }

    if (state.currentInfoWindow && state.currentInfoWindow != location.infoWindow) {
      state.currentInfoWindow.close()
    }

    location.infoWindow.open(state.map, location.marker)
    state.currentInfoWindow = location.infoWindow

    if (window.matchMedia('(min-width: 1024px)').matches) {
      if ($wrapper.hasClass('sidebar-visible')) {
        fn.panCenter(location.marker.getPosition(), 200, 0)
      }
    } else {
      fn.panCenter(location.marker.getPosition(), 0, -120)
    }
  },

  // Sidebar helpers
  showSidebar: () => {
    $wrapper.addClass('sidebar-visible')

    // Offest the map in the x-axis when the sidebar is shown
    let xOffset = null

    if (window.matchMedia('(min-width: 1024px)').matches) {
      xOffset = 200
    }

    if (xOffset) {
      fn.panCenter(state.mapCenter, xOffset, 0)
    }
  },

  hideSidebar: () => {
    $wrapper.removeClass('sidebar-visible')

    // Offest the map in the x-axis when the sidebar is hidden
    let xOffset = null

    if (window.matchMedia('(min-width: 1024px)').matches) {
      xOffset = -50
    }

    if (xOffset) {
      fn.panCenter(state.mapCenter, xOffset, 0)
    }
  },

  toggleSidebarSection: (id) => {
    const $list = $(id)
    const $section = $list.closest('.location-section')
    const $header = $section.find('.location-header')
    const $otherHeader = $('.location-header').not($header)

    $otherHeader.closest('.location-section').find('.location-list').slideUp('fast', () => {
      $otherHeader.attr('aria-expanded', 'false')
    })

    if ($header.attr('aria-expanded') === 'true') {
      $list.slideUp('fast', () => {
        $header.attr('aria-expanded', 'false')
      })
    } else {
      $list.slideDown('fast', () => {
        $header.attr('aria-expanded', 'true')
        state.scrollbars.forEach(sb => sb.update())
      })
    }
  },

  setupMapAutocomplete: (shouldRedirect = false) => {
    $('.map-location-search input[type=text]').flexdatalist({
      minLength: 1,
      cacheLifetime: 120,
      searchDelay: 100,
      searchContain: true,
      searchIn: 'label',
      groupBy: 'groupname',
      data: '/_map/locations/datalist.json'
    }).on('select:flexdatalist', (e, selected) => {
      if (shouldRedirect) {
        window.location.href = selected.maplink
      } else {
        $(window).trigger('viewinglocation', selected.id)
        $(e.target).val(null)
      }
    })
    $('.map-location-search input[type=text]').attr('aria-label', 'Find location by keyword or name')
  },

  panCenter: (latlng, offsetX, offsetY) => {
    const point1 = state.map.getProjection().fromLatLngToPoint(
      (latlng instanceof google.maps.LatLng) ? latlng : state.map.getCenter()
    )

    const point2 = new google.maps.Point(
      ((typeof(offsetX) === 'number' ? offsetX : 0) / Math.pow(2, state.map.getZoom())) || 0,
      ((typeof(offsetY) === 'number' ? offsetY : 0) / Math.pow(2, state.map.getZoom())) || 0
    )

    state.map.panTo(state.map.getProjection().fromPointToLatLng(new google.maps.Point(
      point1.x - point2.x,
      point1.y + point2.y
    )))
  },

  getLocationById: (id) => {
    return state.locations.find(l => l.id === id)
  },

  isMobile: () => {
    return ('ontouchstart' in document.documentElement)
  }
}

export const CampusMap = {
  setupMapAutocomplete: fn.setupMapAutocomplete
}

export default {
  can: () => document.body.classList.contains('pagetype-locationsmap'),
  run: fn.init
}
